import { brandingQueryFragment, useBrandingStyleVariables } from '@insify/funnel-components';

import { isProd } from '../../util/env';

import { useContentful } from './useContentful';

import type { RichContent } from './useContent';
import type { BrandingQuery } from '@insify/funnel-components';

const partnerNameByConfig = window.insify_runtime_config.FRONTEND_FUNNEL_PARTNER;
const enableCoBranding = isProd && !!partnerNameByConfig;

type ContactOptionsCollection = {
  items: {
    text: string;
    link: string;
    iconType: 'email' | 'phone-call' | 'whatsapp';
  }[];
};

type CoBrandingQuery = {
  frConfigCoBrandingCollection: {
    items: {
      partnershipExplained: RichContent;
      homepageLink: string;
      branding: BrandingQuery;
      contactOptions: ContactOptionsCollection;
      contactOptionsDescription: string;
    }[];
  };
};

// TODO: redundant code with other PNC funnels?
export const partnerPreview = (): [showPreview: boolean, partnerName: string | null] => {
  if (isProd) {
    return [false, null];
  }
  const partnerNameByURL = new URLSearchParams(window.location.search).get('partner');
  partnerNameByURL !== null && sessionStorage.setItem('previewPartnerName', partnerNameByURL);
  const partnerName = sessionStorage.getItem('previewPartnerName');
  return [!!partnerName, partnerName];
};

export const useCoBranding = () => {
  const [showPartnerPreview, previewPartnerName] = partnerPreview();
  const partnerName = previewPartnerName || partnerNameByConfig;
  const hasCoBranding = showPartnerPreview || enableCoBranding;
  const { data: { frConfigCoBrandingCollection: { items = [] } = {} } = {} } = useContentful<CoBrandingQuery>(
    'co-branding',
    `${brandingQueryFragment}

    query {
      frConfigCoBrandingCollection(where: { name: "${partnerName}" }) {
        items {
          homepageLink
          partnershipExplained {
            content {
              json
            }
          }
          branding {
            ...Branding
          }
          contactOptions: contactOptionsCollection {
            items {
              text
              link
              iconType
            }
          }
          contactOptionsDescription
        }
      }
    }`,
    showPartnerPreview || enableCoBranding,
  );
  const coBrandingConfig = items[0];
  useBrandingStyleVariables({
    query: items[0]?.branding,
    additionalVariables: {
      '--checkout-partner-explanation-background': 'sidebarBackground',
    },
  });

  return {
    ...coBrandingConfig,
    hasCoBranding,
    hasCoBrandingLoaded: !!coBrandingConfig?.branding,
    partnerName: hasCoBranding ? partnerName : undefined,
  };
};
